import vendorsAPI from '@/api/resources/vendors'
import usersAPI from '@/api/user'
import _ from 'lodash'

const state = {
  allUsers: [],
  caseManagers: [],
  servicesList: [],
  inventoriesList: []
}

const getters = {
  allUsers: state => {
    return _.map(state.allUsers, (u) => {
      return {
        value: u.id,
        text: u.name
      }
    })
  },
  caseManagers: state => state.caseManagers,
  allUsersFull: state => {
    return state.allUsers.sort((a, b) => {
      const nameA = a.name.toUpperCase()
      const nameB = b.name.toUpperCase()

      let comparison = 0
      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }
      return comparison
    })
  },
  servicesList: state => state.servicesList,
  inventoriesList: state => state.inventoriesList,
  getCaseManagerById: (state, getters) => (id) => {
    return state.caseManagers.find(caseManager => caseManager.id === id)
  }
}

const actions = {
  getUserStat () {
    return new Promise((resolve, reject) => {
      usersAPI.getStats().then(result => {
        resolve(result)
      })
    })
  },
  getCurrentVendorsByUser ({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      vendorsAPI.getVendorItems(rootState.currentUser.id).then(result => {
        commit('receiveVendors', result)
        resolve()
      })
    })
  },
  getCaseManagers ({ commit }) {
    return new Promise((resolve, reject) => {
      usersAPI.loadCaseManagers().then(result => {
        commit('receiveCaseManagers', result)
        resolve()
      }, () => {})
    })
  },
  getAllUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      usersAPI.loadUsers().then(result => {
        commit('receiveUsers', result)
        resolve()
      }, () => {})
    })
  }
}

const mutations = {
  receiveVendors (state, vendors) {
    state.servicesList = vendors.services
    state.inventoriesList = vendors.inventories
  },
  receiveCaseManagers (state, managers) {
    state.caseManagers = managers
  },
  receiveUsers (state, users) {
    state.allUsers = users
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/users.js